import {useGuestVariables} from 'Event'
import {useTownhallTemplate} from 'Event/template/Townhall'
import TitleConfig from 'Event/template/Townhall/ForgotPassword/Title/TitleConfig'
import {TitleBase} from 'Event/template/Townhall/Login/Title'
import Configurable from 'organization/Event/Configurable'
import React from 'react'

export default function Title() {
  const {
    login: {
      passwordReset: {forgotPasswordTitle},
    },
  } = useTownhallTemplate()
  const v = useGuestVariables()

  return (
    <Configurable>
      <TitleConfig />
      <TitleBase>{v(forgotPasswordTitle)}</TitleBase>
    </Configurable>
  )
}
